import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography, Grid, debounce, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Stack } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import BottomButtonsforWorkOrder from "./BottomButtonsforWorkOrder";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import { useDispatch, useSelector } from "react-redux";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { decryptDataForHyperlink, updateAssessmentsPartsInitialState, updateAssessmentsPartsRequired, updateBasicDetailsWorkOrder, updateOutsourceDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import { getAuthToken, getCreatedBy, getFacilityId } from "../../utility/tokenUtility";
import { processingPercentageValue, statusList, statusName, workrequest } from "../../utility/message";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoadingOverlay from "../commoncomponents/CustomLoadingOverlay";
import PageLoader from "../commoncomponents/PageLoader";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import CustomDialog from "../commoncomponents/CustomDialog";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { mandatoryFields } from "../../redux/actions/assetActions";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";

export const CancelWorkOrder = ({ open, onClose, onConfirm }) => {
    const [value, setValue] = useState({
        cancelledBy: "",
        reasonforCancellation: "",
    });

    const [errors, setErrors] = useState({
        cancelledBy: false,
        reasonforCancellation: false,
    });

    const [errorMessage, setErrorMessage] = useState({
        cancelledBy: "",
        reasonforCancellation: "",
    });

    const handleChange = (value, name) => {
        setValue((previous) => ({
            ...previous,
            [name]: value,
        }));

        if (value.trim() !== "") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false,
            }));

            setErrorMessage((prevMessages) => ({
                ...prevMessages,
                [name]: "",
            }));
        }
    };

    const handleConfirm = () => {
        const newErrors = {
            cancelledBy: value.cancelledBy.trim() === "",
            reasonforCancellation: value.reasonforCancellation.trim() === "",
        };

        const newErrorMessages = {
            cancelledBy: value.cancelledBy.trim() === "" ? "Cancelled By is required" : "",
            reasonforCancellation: value.reasonforCancellation.trim() === "" ? "Reason for Cancellation is required" : "",
        };

        setErrors(newErrors);
        setErrorMessage(newErrorMessages);

        const isValid = !newErrors.cancelledBy && !newErrors.reasonforCancellation;

        if (isValid) {
            onConfirm(value);
            onClose('yes');
        }
    };

    const handleClose = () => {
        onClose('no');
        setValue({
            cancelledBy: "",
            reasonforCancellation: "",
        });

        setErrorMessage({
            cancelledBy: "",
            reasonforCancellation: "",
        });

        setErrors({
            cancelledBy: false,
            reasonforCancellation: false,
        });

    };

    useEffect(() => {
        if (open) {
            setErrors({
                cancelledBy: false,
                reasonforCancellation: false,
            });
            setErrorMessage({
                cancelledBy: "",
                reasonforCancellation: "",
            });
            setValue({
                cancelledBy: "",
                reasonforCancellation: "",
            })
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Cancel WorkOrder</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Cancelled By"
                            id="cancelledBy"
                            name='cancelledBy'
                            value={value?.cancelledBy}
                            onChange={(e) => handleChange(e, 'cancelledBy')}
                            isMandatoryField={true}
                            error={errors.cancelledBy}
                            errorMessage={errorMessage.cancelledBy}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Reason for Cancellation"
                            id="reasonforCancellation"
                            name="reasonforCancellation"
                            value={value?.reasonforCancellation}
                            onChange={(e) => handleChange(e, 'reasonforCancellation')}
                            isMandatoryField={true}
                            error={errors.reasonforCancellation}
                            errorMessage={errorMessage.reasonforCancellation}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">No</Button>
                <Button onClick={handleConfirm} color="error">Yes</Button>
            </DialogActions>
        </Dialog>
    );
};


const BasicDetails = ({ setPage, page, buttonAttributes }) => {

    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const hyperLinkDecryptData = useSelector((state)=>state?.hyperLinkData)

      // Function to import the key from a Base64 string
 async function importKey(base64Key) {
     const rawKey = base64ToArrayBuffer(base64Key);
     return await crypto.subtle.importKey('raw', rawKey, 'AES-GCM', true, ['decrypt']);
 }
 
 // Function to convert Base64 string to ArrayBuffer
 function base64ToArrayBuffer(base64) {
     const binaryString = window.atob(base64);
     const len = binaryString.length;
     const bytes = new Uint8Array(len);
     for (let i = 0; i < len; i++) {
         bytes[i] = binaryString.charCodeAt(i);
     }
     return bytes.buffer;
 }
 
 // Function to decrypt data using AES-GCM
 async function decryptDataKey(key, encryptedData, iv) {
     const decrypted = await crypto.subtle.decrypt(
         {
             name: "AES-GCM",
             iv: iv,
         },
         key,
         encryptedData
     );
 
     const decoder = new TextDecoder();
     return JSON.parse(decoder.decode(decrypted));
 }
 
 // Retrieve the encrypted state, IV, and key from the URL
 const queryParams = new URLSearchParams(location?.search);
 const encryptedStateString = queryParams?.get("state");
 const ivString = queryParams?.get("iv");
 const keyString = queryParams?.get("key");
 
 const getDecryptData = () =>{
     try {
         if (encryptedStateString && ivString && keyString) {
            setLoading(true);
             // Convert the Base64 encoded data, IV, and key back to ArrayBuffer
             const encryptedData = base64ToArrayBuffer(decodeURIComponent(encryptedStateString));
             const iv = base64ToArrayBuffer(decodeURIComponent(ivString));
         
             // Import the encryption key
             importKey(decodeURIComponent(keyString)).then((key) => {
                 // Decrypt the data
                 decryptDataKey(key, encryptedData, iv).then((decryptedData) => {                    
                     dispatch(decryptDataForHyperlink("DECRYPT_DATA_REDUCERS_HYPERLINK",decryptedData))
                 }).catch((error) => {
                     console.log("Decryption failed:", error);
                 });
             });
         }
     } catch (error) {
         console.log("Decryption failed:", error)
     }
 }

    const basicDetails = useSelector((state) => state.workOrderBasicDetails);
    const mandatoryBasicDetails = useSelector((state) => state.workOrdermandatoryFields.mandatoryFieldsBasicDetails);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const getStepper = useSelector((state) => state?.checkParts);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
    const editServiceType = location.state?.service || hyperLinkDecryptData?.service;
    const viewmode = location.state?.viewmode;
    const workorderCategoryType = location.state?.category || hyperLinkDecryptData?.category;
    const targetResponse = [{ id: 1, label: "120 Mins", }, { id: 2, label: "15 Mins", }];
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const categoryType = assetCategoryType?.category || "";
    const setScheduledField = categoryType === "Scheduled" ? true : false;
    const checkIsHyperLink = location?.state?.isHyperlink || hyperLinkDecryptData?.isHyperlink ? true : false;
    const workOrderType = location?.state?.workordertype || hyperLinkDecryptData?.workordertype || "";
    const checkWorkOrderType = workOrderType === "PDM" ? true : false;
    const facilityId = getFacilityId('facilityId');
    const token = getAuthToken("id_token");
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGT001");

    const [basicDetailsdata, setBasicDetailsData] = useState(basicDetails || {});
    const [gridApi, setGridApi] = useState({});
    const [isWorkRequestNoSelected, setIsWorkRequestNoSelected] = useState(false);
    const [openAutoAsignDialog, setOpenAutoAsignDialog] = useState(false);
    const [confirmationAutoAsign, setConfirmationAutoAsign] = useState(false);
    const [cancelAutoAssign, setCancelAutoAsign] = useState(false);
    const [enable, setEnable] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pageNavigate, setPageNavigate] = useState(false);
    const [checkAutoAsign, setCheckAutoAsign] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorDialogMssg, setErrorDialogMssg] = useState("");
    const [error, setError] = useState({
        workorderDateandTime: false,
        requestor: false,
        designation: false,
        assetNo: false,
        requestDetails: false,
        recivedDateandTime: false
    });
    const [errorMessage, setErrorMessage] = useState({
        workorderDateandTime: "",
        requestor: "",
        designation: "",
        assetNo: "",
        requestDetails: "",
        recivedDateandTime: ""
    });
    const [basicDetailsOptions, setBasicDetailsOptions] = useState(
        {
            workRequestNo: [],
            assetNo: [],
            type: [],
            priority: [],
            category: [],
        }
    );

    const statusMapping = {
        "Open": 1,
        "Scheduled": 2,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
        "In Progress-Outsource":10

    };

    
    
    const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value
    const checkcancelWOStatus = (status === "Open" || status === "In Progress" || status === "Cancelled" || status === "Scheduled" || status === "In Progress-Outsource") ? true : false;

    const serviceName = basicDetailsdata?.referenceWorkRequestNo?.serviceName === "FEMS" ? "fem" : "bem" ?
        basicDetailsdata?.assetNo?.serviceName === "FEMS" ? "fem" : "bem" : '';

    const handleOnchange = (value, name, errorStateName) => {
        if (name === "requestor" || name === "requestDetails") {
            if (value?.startsWith(" ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not start with spaces`,
                }));
                return;
            } else if (value?.endsWith("  ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not end with spaces`,
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    [name]: false,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: "",
                }));
            }
        }

        if (name === 'contactNo') {
            const regex = /[^0-9+\-()/]/g;
            value = value.replace(regex, ''); // Filter the value to allow only numbers, +, and -
        }


        setBasicDetailsData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };

            if (name === "assetNo" && value?.id) {
                updatedData.assetNo = { ...value, label: value?.assetNo ? value?.assetNo : '' };
                updatedData.oldAssetNo = value?.oldAssetNo;
                updatedData.underwarrenty = value?.underwarrenty;
                updatedData.description = value?.assetdesc;
                updatedData.location = value?.location;
                updatedData.workgroupDescription = value?.workGroupcodeDesc;
                updatedData.priority = { id: value?.priorityId, label: value?.priorityName };
                updatedData.targetResponse = value?.priorityId === 1 ? targetResponse[0].label : targetResponse[1].label;
            } else if (name === "assetNo") {
                updatedData.assetNo = "";
                updatedData.oldAssetNo = "";
                updatedData.underwarrenty = "";
                updatedData.description = "";
                updatedData.location = "";
                updatedData.workgroupDescription = "";
                updatedData.priority = {key: 'option1', label: 'Normal', isvisible: true, id: 1};
                updatedData.targetResponse = targetResponse[0].label;
            };
            
            if (name === "referenceWorkRequestNo" && value?.id) {
                updatedData.referenceWorkRequestNo = { ...value, label: value?.label ? value?.label : '' };
                updatedData.issueDateandTimeBasicDetails = value?.deptWorkRequestDate;
                updatedData.assetNo = value?.assetNo;
                updatedData.oldAssetNo = value?.oldAssetNo;
                updatedData.underwarrenty = value?.underwarrenty;
                updatedData.description = value?.assetdesc;
                updatedData.location = value?.location;
                updatedData.workgroupDescription = value?.workGroupcodeDesc;
                updatedData.contactNo = value?.contactNo;
                updatedData.requestor = value?.requestor;
                updatedData.designation = value?.designation;
                updatedData.requestDetails = value?.requestDetails;
                updatedData.category = value?.category;
                updatedData.type = value?.type;
                updatedData.priority = { id: value?.priorityId, label: value?.priorityName };
                if (value?.id) {
                    setError((prev) => {
                        return {
                            ...prev,
                            requestor: false,
                            assetNo: false,
                            requestDetails: false
                        }
                    });
                    setErrorMessage((prev) => {
                        return {
                            ...prev,
                            requestor: "",
                            assetNo: "",
                            requestDetails: ""
                        }
                    });
                };

            } else if (name === "referenceWorkRequestNo") {
                updatedData.referenceWorkRequestNo = "";
                updatedData.issueDateandTimeBasicDetails = "";
                updatedData.assetNo = { id: "", label: "" };
                updatedData.oldAssetNo = "";
                updatedData.underwarrenty = "";
                updatedData.description = "";
                updatedData.location = "";
                updatedData.workgroupDescription = "";
                updatedData.contactNo = "";
                updatedData.requestor = "";
                updatedData.designation = "";
                updatedData.requestDetails = "";
                updatedData.category = { key: "option1", label: "Unscheduled", isvisible: true, id: 1 };
                updatedData.type = { key: "option1", label: "Breakdown", isvisible: true, id: 1, femworkordercategoryId: 1 };
                updatedData.priority = {key: 'option1', label: 'Normal', isvisible: true, id: 1};
            };

            if (name === "priority") {
                if (value?.id === 1) {
                    updatedData.targetResponse = targetResponse[0].label;
                } else if (value?.id === 2) {
                    updatedData.targetResponse = targetResponse[1].label;
                } else {
                    updatedData.targetResponse = "";
                }
            };

            return updatedData;
        });

        const workOrderDateAndTime = basicDetailsdata?.workorderDateandTime || basicDetails?.workorderDateandTime;

        if (name === 'recivedDateandTime' && value && workOrderDateAndTime) {
            const workOrderDate = new Date(workOrderDateAndTime);
            const selectedDate = new Date(value);

            // Allow if selectedDate is the same or greater than workOrderDate
            if (selectedDate.getTime() < workOrderDate.getTime()) {
                setError((prev) => ({
                    ...prev,
                    recivedDateandTime: true
                }));

                setErrorMessage((prev) => ({
                    ...prev,
                    recivedDateandTime: "Received Start date and time should be greater than or equal to the work order date and time."
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    recivedDateandTime: false
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    recivedDateandTime: ""
                }));
            }
        }

        setError((prev) => {
            const updatedError = {
                ...prev,
                [name]: false
            };
            return updatedError;
        });

        setErrorMessage((prev) => ({
            ...prev,
            [name]: ''
        }));

        if (name === "referenceWorkRequestNo") {
            setIsWorkRequestNoSelected(value?.label !== "");
        };
    };

    const memoizedDetails = useMemo(() => ({
        workorderDateandTime: basicDetailsdata?.workorderDateandTime || '',
        requestor: basicDetailsdata?.requestor || '',
        assetNo: basicDetailsdata?.assetNo || '',
        requestDetails: basicDetailsdata?.requestDetails || '',
        recivedDateandTime: basicDetailsdata?.recivedDateandTime || '',
    }), [
        basicDetailsdata?.workorderDateandTime,
        basicDetailsdata?.requestor,
        basicDetailsdata?.assetNo,
        basicDetailsdata?.requestDetails,
        basicDetailsdata?.recivedDateandTime,
    ]);

    //function to check the mandatory field are filled or not(responsible for green ticks on left side)
    const checkMandatoryValueFilled = useCallback(debounce((
        workorderDateandTime,
        requestor,
        assetNo,
        requestDetails,
        recivedDateandTime
    ) => {
        const updateStatus = (type, value, name, isVisible, errorState) => ({
            type,
            valueFilled: !errorState && !!value,
            name,
            isVisible
        });

        const updateDateandTimeBasicDetails = updateStatus("Date and Time", workorderDateandTime, 'workorderDateandTime', true, error?.workorderDateandTime);
        const updaterequestor = updateStatus("Requestor", requestor, 'requestor', !setScheduledField, error?.requestor);
        const updateassetNo = updateStatus("Asset No", assetNo, 'assetNo', !setScheduledField, error?.assetNo);
        const updaterequestDetails = updateStatus(
            "Request Details",
            requestDetails,
            'requestDetails',
            setScheduledField ? (setScheduledField && !checkWorkOrderType) : true,
            error?.requestDetails
        );        
        const updateRecivedDateandTime = updateStatus("Received Date and Time", recivedDateandTime, 'recivedDateandTime', !setScheduledField, error?.recivedDateandTime);

        const arrayAfterUpdating = [
            updateDateandTimeBasicDetails,
        ];

        if (setScheduledField ? (setScheduledField && !checkWorkOrderType) : true) {
            arrayAfterUpdating.push(updaterequestDetails);
        };

        if (!setScheduledField) {
            arrayAfterUpdating.push(updaterequestor);
            arrayAfterUpdating.push(updateRecivedDateandTime);
            arrayAfterUpdating.push(updateassetNo);
        };

        if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
            dispatch({ type: "UPDATE_WORK_ORDER_BASIC_DETAILS_MANDATORY_FIELDS", payload: arrayAfterUpdating })
        };
    }), [dispatch, !setScheduledField, error]);

    useEffect(() => {
        const {
            workorderDateandTime,
            requestor,
            assetNo,
            requestDetails,
            recivedDateandTime
        } = memoizedDetails;
        checkMandatoryValueFilled(
            workorderDateandTime,
            requestor?.trim(),
            assetNo?.id,
            requestDetails?.trim(),
            recivedDateandTime
        );
    }, [
        memoizedDetails,
        checkMandatoryValueFilled
    ], []);

    const handleValidationForRequiredFields = () => {
        let isValid = true;
        mandatoryBasicDetails.map((item) => {
            if (item.valueFilled === false) {
                setError((prev) => ({
                    ...prev,
                    [item.name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [item?.name]: prev[item?.name] || `${item?.type} is required `,
                }));
                isValid = false;
            }
        });
        return isValid;
    };


    const assetNoOptions = async () => {
        let requestNoService = basicDetailsdata?.referenceWorkRequestNo?.serviceName || "";
        let service = serviceType === "fem" ? "FEMS" : "BEMS";
        let servicecategory = editServiceType ? editServiceType : requestNoService || service

        if(!setScheduledField){
            const assetNo = (basicDetailsdata?.referenceWorkRequestNo?.id ? basicDetailsdata?.referenceWorkRequestNo?.id : basicDetailsdata?.assetNo?.id) ? await workOrderSummaryRepositry.fetchAssetNobyService(servicecategory) : await workOrderSummaryRepositry.fetchAssetNo();
        setBasicDetailsOptions((prevOptions) => ({
            ...prevOptions,
            assetNo: assetNo?.map((item, index) => {
                return {
                    key: `option${index}`,
                    id: item?.assetId || "",
                    label: `${item?.assetdescno || ""} - ${item?.assetdesc || ""}` || "",
                    assetNo: item?.assetdescno || "",
                    location: item?.locationdesc || "",
                    locationCode:item?.locationcode || "",
                    underwarrenty: item?.isunderwarranty === true
                        ? "Yes"
                        : item?.isunderwarranty === false
                            ? "No"
                            : "",
                    assetdesc: item?.assetdesc || "",
                    workGroupId: item?.wgId || "",
                    workGroupcodeDesc: `${(item?.wgId && item?.wgcode) ? item?.wgcode : ""}${(item?.wgcode && item?.wgdesc) ? " - " : ""}${(item?.wgId && item?.wgdesc) ? item?.wgdesc : ""}` || "",
                    oldAssetNo: item?.oldassetno || "",
                    serviceId: item?.serviceId || "",
                    serviceName: item?.serviceName || "",
                    priorityId: item?.criticalityId || 1,
                    priorityName: item?.criticality || "Normal",
                    repairType:"Inhouse",
                  //  repairType:item?.repairType || "Inhouse",
                };

            })

        }));
        }
    };

    const workrequestNoOptions = async () => {
        if(location?.state?.isCreateMode && !setScheduledField){
            const workrequestNo = await workOrderSummaryRepositry.fetchWorkRequestNo();
                setBasicDetailsOptions((prevOptions) => ({
                    ...prevOptions,
                    workRequestNo: workrequestNo?.map((item, index) => {
                        return {
                            key: `option${index}`,
                            id: item?.deptworkRequestId || "",
                            label: item?.deptworkrequestno || "",
                            // assetNo: { label: item?.assetno || "", id: item?.assetId || "", repairType:item?.repairType || "Inhouse"},
                            assetNo: { label: item?.assetno || "", id: item?.assetId || "", repairType:"Inhouse"},
                            location: item?.locationName || "",
                            underwarrenty: item?.isunderwarranty === true ? "Yes" : item?.isunderwarranty === false ? "No" : "",
                            assetdesc: item?.assetdesc || "",
                            workGroupId: item?.wgId || "",
                            workGroupcodeDesc: `${item?.workcode} - ${item?.workgroup}` || "",
                            oldAssetNo: item?.oldAssetno || "",
                            contactNo: item?.contactno || "",
                            deptWorkRequestDate: item?.deptworkrequestdate || "",
                            requestor: item?.requestor || "",
                            designation: item?.designation || "",
                            requestDetails: item?.requestdetails || "",
                            serviceId: item?.serviceid || "",
                            serviceName: item?.serviceDesc || "",
                            category: { label: item?.workordercategory || "", id: item?.workordercategoryId || "" },
                            type: { label: item?.workordertype || "", id: item?.[`${serviceType}workordertypeId`] || "", femworkordercategoryId: item?.workordercategoryId || "" },
                            // repairType:item?.repairType || "Inhouse",
                           repairType:"Inhouse",
                            priorityId: item?.criticalityId  || 1,
                            priorityName: item?.criticality  || "Normal",
                        };
                    })
                }));
        }
        

    };

    const categoryandPriorityOptions = async () => {
        const categoryandPriority = await workOrderSummaryRepositry.lovOptions()
        setBasicDetailsOptions((prevOptions) => ({
            ...prevOptions,
            priority: categoryandPriority?.femworkorderpriority?.map((item) => ({
                key: `option${item?.id}`,
                label: item?.workorderpriority,
                isvisible: item?.isvisible,
                id: item?.id
            })),

            category: categoryandPriority?.femworkordercategory?.map((item) => ({
                key: `option${item?.id}`,
                label: item?.workordercategory,
                isvisible: item?.isvisible,
                id: item?.id
            })),
        }));

    };

    useEffect(() => {
        dispatch({
            type: "SERVICE&CATEGORY_TYPE", payload: {
                assetType: editServiceType ? editServiceType : serviceName,
                category: workorderCategoryType ? workorderCategoryType : 'Unscheduled'
            }
        })
        if(!basicDetails?.editmode){            
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", basicDetailsdata?.assetNo?.repairType === 'Outsource' ? true : false));
        }

    }, [basicDetailsdata?.referenceWorkRequestNo, basicDetailsdata?.assetNo, basicDetailsdata?.category, categoryType, workorderCategoryType, editServiceType, setScheduledField])

    const fetchTypes = async () => {
        if(!setScheduledField){
            const type = await workOrderSummaryRepositry.fetchTypes(basicDetailsdata?.category?.id);
            setBasicDetailsOptions((prevOptions) => ({
                ...prevOptions,
                type: type?.map((item) => (
                    {
                        key: `option${item?.id}`,
                        label: item?.workordertype,
                        isvisible: item?.isvisible,
                        id: item?.id,
                        femworkordercategoryId: item?.femworkordercategoryId
                    })).filter(type => (type?.femworkordercategoryId === 1 && (type?.id === 1 || type?.id === 2 || type?.id === 8)) || type?.femworkordercategoryId === 3 || type?.femworkordercategoryId === 2)
            }));
        }
        
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            if (location?.state?.id || hyperLinkDecryptData?.id || "") {
        
                

                if (workorderCategoryType === "Scheduled") {
                    const response = await workOrderSummaryRepositry.getWorkOrderSummary(editServiceType, location?.state?.id || hyperLinkDecryptData?.id, workorderCategoryType, workOrderType);
                    
                    if (editServiceType === 'fem') {
                        const data = response?.[0];
                        const getRepairtype = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype ? data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype : data?.femworespondtype || ''
                        const setvendorField = getRepairtype === 'Outsource' ? true : false;
                        
                        const status = data?.femscheduledworkorderheaders?.[0]?.femworkorderstatus?.workorderstatus || "";
                        const percentageStatus = data?.femscheduledworkorderheaders?.[0]?.processingpercentage || "";
                        const setProcessingPercentage = (status === statusList?.completed?.label || status === statusList?.completedOutsource?.label || status === statusList?.verified?.label) ? 92 : status === statusList?.closed?.label ? 100 : percentageStatus
                        
                        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: setProcessingPercentage }));

                        const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                        const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                        const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
                        const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType, categoryType);

                        const mapEmployeeIdToName = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeename : '';
                        };

                        const mapEmployeeIdTodesignation = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.designation : '';
                        };

                        const mapEmployeeIdToCode = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeecode : '';

                        };

                        const maptoVendorDetails = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorname : '';
                        };

                        const maptoVendorCode = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorcode : '';
                        };

                        const mapFlagIdToLabel = (id) => {
                            const flag = lovOptionsResponse?.femschworepairflags?.find(f => f?.id === id);
                            return flag ? flag?.repairflag : '';
                        };

                        const mapPicIdToLabel = (id) => {
                            const pic = lovOptionsResponse?.femschworepairpics?.find(p => p?.id === id);
                            return pic ? pic?.repairpic : '';
                        };

                        const mapActivityIdToLabel = (id) => {
                            const activity = lovOptionsResponse?.femschworepairactivities?.find(a => a?.id === id);
                            return activity ? activity?.repairactivity : '';
                        };

                        const mapItemCode = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.itemcode : '';
                        };

                        const maptoUnitCost = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.unitcost : '';
                        };

                        const mapItemDesc = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic.descriptionname : '';
                        };

                        // Mapping repairTracker data
                        const repairTracker = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders[0]?.femscheduledworepairdetails?.map((repairDetail) => {
                            return {
                                employeename: {
                                    id: repairDetail?.employeeid || "",
                                    employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                    employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                },
                                flag: {
                                    id: repairDetail?.femschworepairflagId || "",
                                    label: mapFlagIdToLabel(repairDetail?.femschworepairflagId) || ""
                                },
                                pic: {
                                    id: repairDetail?.femschworepairpicId || "",
                                    label: mapPicIdToLabel(repairDetail?.femschworepairpicId) || ""
                                },
                                activity: {
                                    id: repairDetail?.femschworepairactivityId || "",
                                    label: mapActivityIdToLabel(repairDetail?.femschworepairactivityId) || ""
                                },
                                technician: repairDetail?.vendortechnician || "",
                                startDateandTime: repairDetail?.repairstartdate || "",
                                endDateandTime: repairDetail?.repairenddate || "",
                                repairDuration: repairDetail?.repairduration || "",
                                remarks: repairDetail?.remarks || "",
                                preparationHours: repairDetail?.preparationhours || "",
                                verificationHours: repairDetail?.verificationhours || "",
                                id: repairDetail?.id || "",
                                timeStamp: repairDetail?.timestamp || "",
                            };
                        }) || [];
                        
                        // Mapping repairTracker data
                        const partReplacement = data?.femscheduledworkorderheaders[0]?.femscheduledwopartsreplacedetails.map((partDetails) => {
                            return {
                                itemPartCode: {
                                    id: partDetails?.itemcodeid || "",
                                    label: mapItemCode(partDetails?.itemcodeid) || "",
                                    unitCost:maptoUnitCost(partDetails?.itemcodeid) || "",
                                },
                                itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                quantity: partDetails?.quantityused || "",
                                partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
                                id: partDetails?.id || "",
                                timeStamp: partDetails?.timestamp || "",
                                editmode: true
                            };
                        }) || [];

                        const assetNo = {
                            id: data?.assetId || "",
                            label: data?.assetNo || "",
                            workGroupId:data?.wgId || "",
                            repairType:data?.femworespondtype || ""
                        };

                        const respondedBy = {
                            id: data?.assessmentEmployeeId ? data?.assessmentEmployeeId : data?.scheduleEmployeeId || "",
                            label:data?.assessmentEmployeename ? data?.assessmentEmployeename : data?.scheduleEmployeename || "",
                            employeecode: mapEmployeeIdToCode(data?.assessmentEmployeeId || data?.scheduleEmployeeId) || "",

                        };

                        const taskcode = {
                            id: data?.taskcodeId ? data?.taskcodeId : data?.scheduledTaskcodeId || "",
                            label: data?.taskcode ? data?.taskcode : data?.scheduledTaskcode || ""
                        };

                        const partsRequired = {
                            id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 1
                                : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 2
                                    : "",
                            label: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 'Yes'
                                : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 'No'
                                    : ""
                        };

                        const withPartsRequired = getStepper;
                        const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                        if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                            dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                        } else {
                            dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                        };

                        const assetTakenLocation = {
                            id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 1
                                : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 2
                                    : "",
                            label: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 'Yes'
                                : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 'No'
                                    : ""
                        };


                        const compRespondedBy = {
                            id: data?.completionEmployeeId || "",
                            label: data?.completionEmployeename || "",
                            designation: mapEmployeeIdTodesignation(data?.completionEmployeeId) || ""
                        };

                        const vendor = {
                            id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId || "",
                            label: maptoVendorDetails(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid) || data?.vendorname || "",
                            vendorcode: maptoVendorCode(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                        };
                        
                        const mappedData = {
                            id: location?.state?.id || hyperLinkDecryptData?.id ||"",
                            serviceType: editServiceType || "",
                            workOrderNo: data?.workorderno || '',
                            issueDateandTimeBasicDetails:data?.femscheduledworkorderheaders[0]?.targetdate || "",
                            workorderDateandTime: data?.workorderdate || "",
                            requestor: data?.femscheduledworkorderheaders[0]?.requestor || '',
                            designation: data?.femscheduledworkorderheaders[0]?.designation || '',
                            contactNo: data?.femscheduledworkorderheaders[0]?.contactno || '',
                            assetNo: assetNo || [],
                            oldAssetNo: data?.femscheduledworkorderheaders[0]?.femassetregister?.oldassetNo || '',
                            description: data?.assetDescription || "",
                            underwarrenty: data?.femscheduledworkorderheaders[0]?.femassetregister?.isunderwarranty === true
                                ? "Yes"
                                : data?.femscheduledworkorderheaders[0]?.femassetregister?.isunderwarranty === false
                                    ? "No"
                                    : '',
                            location: data?.locationdesc || '',
                            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                            workGroupId: data?.wgId || "",
                            requestDetails: data?.femscheduledworkorderheaders[0]?.requestdetails || '',
                            recivedDateandTime: data?.femscheduledworkorderheaders[0]?.receiveddate || "",
                            category: {
                                label: data?.workordercategory || "",
                                isvisible: true || "",
                                id: data?.femscheduledworkorderheaders[0]?.femworkordertype?.femworkordercategoryId || ""
                            },
                            type: {
                                label: data?.femscheduledworkorderheaders[0]?.femworkordertype?.workordertype || "",
                                isvisible: true,
                                id: data?.femscheduledworkorderheaders[0]?.femworkordertype?.id || ""
                            },
                            priority: {
                                label:location?.state?.deptid?.criticality || data?.femscheduledworkorderheaders[0]?.femworkorderpriority?.workorderpriority ||  "Normal",
                                isvisible: true,
                                id:location?.state?.deptid?.criticalityId ||  data?.femscheduledworkorderheaders[0]?.femworkorderpriority?.id || 1,
                            },
                            targetResponse: data?.femscheduledworkorderheaders[0]?.femwotargetresponse?.targetresponse || "",
                            cancelledBy: data?.femscheduledworkorderheaders[0]?.cancelledby || '',
                            reasonforCancellation: data?.femscheduledworkorderheaders[0]?.cancellationreason || '',
                            ppmscheduletrackId: data?.femscheduledworkorderheaders[0]?.femppmscheduletrackId || "",
                            pdmscheduletrackId: data?.femscheduledworkorderheaders[0]?.fempredictivemaintenancetrackId || "",
                            performancetest:data?.femscheduledworkorderheaders[0]?.performancetest || "",
                            electricalsafteytest:data?.femscheduledworkorderheaders[0]?.electricalsafteytest || "",
                            processstatus:data?.femscheduledworkorderheaders[0]?.processstatus || "",
                            completionInfo: {
                                id: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.id || '',
                                respondedBy: compRespondedBy || '',
                                designation: data?.completionDesignation || '',
                                respondedDateandTime: data?.femscheduledworepairdetails?.[0]?.femscheduledwoassessmentheader?.[0]?.responsestartdate || "",
                                duration: data?.duration || '',
                                completionBy: {
                                    id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                    label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                    value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                },
                                startDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.startdate || '',
                                endDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.enddate || '',
                                actionTaken: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                signatureFiles: [],
                                timeStamp: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.timeStamp || "",
                                costInfo: {
                                    editmode: true,
                                    breakDownCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                    poNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
                                    ppmCostByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                    poNumberByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
                                    ppmCostByContract: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                    contractReferenceNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractrefno || "",
                                    totalSparePartCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                    totalWorkorderCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0,
                                }
                            },
                            assessments: {
                                id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.id || '',
                                respondedBy: respondedBy || '',
                                designation:data?.scheduleDesignation ? data?.scheduleDesignation : data?.assessmentDesignation || "",
                                respondedStartDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
                                respondedEndDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.responseenddate || '',
                                taskCode: taskcode || '',
                                taskDescription:data?.taskdesc ? data?.taskdesc : data?.scheduledTaskdesc || '',
                                repairType:data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype ? data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype : data?.femworespondtype || '',
                                partsRequired: partsRequired || '',
                                assetTakenLocation: assetTakenLocation || '',
                                respondedFinding: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                repairTracker: repairTracker || [],
                                vendor: vendor || '',
                                outsourceRespondRemarks: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                                timeStamp: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.timestamp || "",
                            },
                            partReplacementRows: partReplacement || [],
                            Authorizedby: data?.authorizedby || "",
                            AuthorizedbyDate: data?.authorizedbyDate || "",
                            Closeddate :data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.authorizeddate || "",
                            Closedid :data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.authorizedbyid || "",
                            timeStamp: location?.state?.timestamp || '',
                            editmode: true,
                            // completedby : data?.femscheduledworkorderheaders?.[0]?.completedby || "",
                            // completeddate : data?.femscheduledworkorderheaders?.[0]?.completeddate || "",
                            
                        };                        
                        
                        setBasicDetailsData(mappedData);
                        dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                        dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                        setLoading(false);

                    } else {
                        const data = response?.[0];
                        const getRepairtype = data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype ? data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype : data?.bemworespondtype || ''
                        const setvendorField = getRepairtype === 'Outsource' ? true : false;
                        const status = data?.bemscheduledworkorderheaders?.[0]?.bemworkorderstatus?.workorderstatus || "";
                        const percentageStatus = data?.bemscheduledworkorderheaders[0]?.processingpercentage || "";
                        const setProcessingPercentage = (status === statusList?.completed?.label || status === statusList?.completedOutsource?.label || status === statusList?.verified?.label) ? 92 : status === statusList?.closed?.label ? 100 : percentageStatus
                        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: setProcessingPercentage }))

                        const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                        const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                        const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
                        const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType, categoryType);

                        const mapEmployeeIdToName = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee.employeename : '';
                        };

                        const mapEmployeeIdTodesignation = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.designation : '';
                        };

                        const mapEmployeeIdToCode = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeecode : '';

                        };

                        const mapFlagIdToLabel = (id) => {
                            const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
                            return flag ? flag?.repairflag : '';
                        };

                        const maptoVendorDetails = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorname : '';
                        };

                        const maptoVendorCode = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorcode : '';
                        };

                        const mapPicIdToLabel = (id) => {
                            const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
                            return pic ? pic?.repairpic : '';
                        };

                        const mapActivityIdToLabel = (id) => {
                            const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
                            return activity ? activity?.repairactivity : '';
                        };

                        const mapItemCode = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic.itemcode : '';
                        };
                        const mapItemDesc = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.descriptionname : '';
                        };

                        const maptoUnitCost = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.unitcost : '';
                        };

                        // Mapping repairTracker data
                        const repairTracker = data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemscheduledworepairdetails?.map((repairDetail) => {
                            return {
                                employeename: {
                                    id: repairDetail?.employeeid || "",
                                    employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                    employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                },
                                flag: {
                                    id: repairDetail?.bemschworepairflagId || '',
                                    label: mapFlagIdToLabel(repairDetail?.bemschworepairflagId) || ''
                                },
                                pic: {
                                    id: repairDetail?.bemschworepairpicId || '',
                                    label: mapPicIdToLabel(repairDetail?.bemschworepairpicId) || ''
                                },
                                activity: {
                                    id: repairDetail.bemschworepairactivityId || '',
                                    label: mapActivityIdToLabel(repairDetail?.bemschworepairactivityId) || ''
                                },
                                technician: repairDetail?.vendortechnician || "",
                                startDateandTime: repairDetail?.repairstartdate || "",
                                endDateandTime: repairDetail?.repairenddate || "",
                                repairDuration: repairDetail?.repairduration || "",
                                remarks: repairDetail?.remarks || '',
                                preparationHours: repairDetail?.preparationhours || '',
                                verificationHours: repairDetail?.verificationhours || '',
                                id: repairDetail?.id || "",
                                timeStamp: repairDetail?.timestamp || ""
                            };
                        }) || [];

                        const partReplacement = data?.bemscheduledworkorderheaders[0]?.bemscheduledwopartsreplacedetails?.map((partDetails) => {
                            return {
                                itemPartCode: {
                                    id: partDetails?.itemcodeid || "",
                                    label: mapItemCode(partDetails?.itemcodeid) || "",
                                    unitCost: maptoUnitCost(partDetails?.itemcodeid) || ""
                                },
                                itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                quantity: partDetails?.quantityused || "",
                                partCost: parseFloat(partDetails?.partscost || 0).toFixed(2) || "",
                                id: partDetails?.id || "",
                                editmode: true,
                                timeStamp: partDetails?.timestamp || "",
                            };
                        }) || [];



                        const assetNo = {
                            id: data?.assetId || "",
                            label: data?.assetNo || "",
                            workGroupId:data?.wgId || "",
                            repairType:data?.bemworespondtype || ""
                        };

                        const respondedBy = {
                            id: data?.assessmentEmployeeId ? data?.assessmentEmployeeId : data?.scheduleEmployeeId || "",
                            label:data?.assessmentEmployeename ? data?.assessmentEmployeename : data?.scheduleEmployeename || "",
                            employeecode: mapEmployeeIdToCode(data?.assessmentEmployeeId || data?.scheduleEmployeeId) || "",
                        };

                        const taskcode = {
                            id: data?.taskcodeId ? data?.taskcodeId : data?.scheduledTaskcodeId || "",
                            label: data?.taskcode ? data?.taskcode : data?.scheduledTaskcode || ""
                        };

                        const partsRequired = {
                            id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 1
                                : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 2
                                    : "",
                            label: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 'Yes'
                                : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 'No'
                                    : ""
                        };
                        const withPartsRequired = getStepper;
                        const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                        if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                            dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                        } else {
                            dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                        };

                        const assetTakenLocation = {
                            id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 1
                                : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 2
                                    : "",
                            label: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 'Yes'
                                : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 'No'
                                    : ""
                        };

                        const compRespondedBy = {
                            id: data?.completionEmployeeId || "",
                            label: data?.completionEmployeename || "",
                            designation: mapEmployeeIdTodesignation(data?.completionEmployeeId) || ""
                        };

                        const vendor = {
                            id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId || "",
                            label: maptoVendorDetails(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid) || data?.vendorname || "",
                            vendorcode: maptoVendorCode(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                        };
                        
                        const mappedData = {
                            id: location?.state?.id || hyperLinkDecryptData?.id || "",
                            serviceType: editServiceType || "",
                            workOrderNo: data?.workorderno || '',
                            issueDateandTimeBasicDetails: data?.bemscheduledworkorderheaders?.[0]?.targetdate || "",
                            workorderDateandTime: data?.workorderdate || "",
                            requestor: data?.bemscheduledworkorderheaders?.[0]?.requestor || '',
                            designation: data?.bemscheduledworkorderheaders?.[0]?.designation || '',
                            contactNo: data?.bemscheduledworkorderheaders?.[0]?.contactno || '',
                            assetNo: assetNo || [],
                            oldAssetNo: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.oldassetNo || '',
                            description: data.assetDescription || "",
                            underwarrenty: data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === true
                                ? "Yes"
                                : data?.bemscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === false
                                    ? "No"
                                    : '',
                            location: data.locationdesc || '',
                            workGroupId: data?.wgId || "",
                            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                            requestDetails: data?.bemscheduledworkorderheaders?.[0]?.requestdetails || '',
                            recivedDateandTime: data?.bemscheduledworkorderheaders?.[0]?.receiveddate || "",
                            category: {
                                label: data?.workordercategory || "",
                                isvisible: true,
                                id: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.bemworkordercategoryId || ""
                            },
                            type: {
                                label: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
                                isvisible: true,
                                id: data?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.id || ""
                            },
                            priority: {
                                label:location?.state?.deptid?.criticality || data?.bemscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority ||  "Normal",
                                isvisible: true,
                                id: location?.state?.deptid?.criticalityId || data?.bemscheduledworkorderheaders?.[0]?.bemworkorderpriority?.id || 1,
                            },
                            targetResponse: data?.bemscheduledworkorderheaders?.[0]?.bemwotargetresponse?.targetresponse || "",
                            cancelledBy: data?.bemscheduledworkorderheaders?.[0]?.cancelledby || '',
                            reasonforCancellation: data?.bemscheduledworkorderheaders?.[0]?.cancellationreason || '',
                            ppmscheduletrackId: data?.bemscheduledworkorderheaders?.[0]?.bemppmscheduletrackId || "",
                            pdmscheduletrackId: data?.bemscheduledworkorderheaders[0]?.bempredictivemaintenancetrackId || "",
                            performancetest:data?.bemscheduledworkorderheaders?.[0]?.performancetest || "",
                            electricalsafteytest:data?.bemscheduledworkorderheaders?.[0]?.electricalsafteytest || "",
                            processstatus:data?.bemscheduledworkorderheaders?.[0]?.processstatus || "",
                            completionInfo: {
                                id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.id || '',
                                respondedBy: compRespondedBy || '',
                                designation: data?.completionDesignation || '',
                                respondedDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheader?.[0]?.responsestartdate || "",
                                duration: data?.duration || '',
                                completionBy: {
                                    id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                    label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                    value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                },
                                startDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.startdate || '',
                                endDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.enddate || '',
                                actionTaken: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                signatureFiles: [],
                                timeStamp: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.timestamp || '',
                                costInfo: {
                                    editmode: true,
                                    breakDownCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                    poNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                                    ppmCostByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                    poNumberByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                                    ppmCostByContract: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                    contractReferenceNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractrefno || '',
                                    totalSparePartCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                    totalWorkorderCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0
                                }
                            },
                            assessments: {
                                id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders[0]?.id || '',
                                respondedBy: respondedBy || '',
                                designation: data?.scheduleDesignation ? data?.scheduleDesignation : data?.assessmentDesignation || "",
                                respondedStartDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
                                respondedEndDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responseenddate || '',
                                taskCode: taskcode || '',
                                taskDescription: data?.taskdesc ? data?.taskdesc : data?.scheduledTaskdesc || '',
                                repairType:data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype ? data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype : data?.bemworespondtype || '',
                                partsRequired: partsRequired || '',
                                assetTakenLocation: assetTakenLocation || '',
                                respondedFinding: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                repairTracker: repairTracker || [],
                                timeStamp: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.timestamp || "",
                                vendor: vendor || "",
                                outsourceRespondRemarks: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                            },
                            partReplacementRows: partReplacement,
                            timeStamp: location?.state?.timestamp || "",
                            Authorizedby: data?.authorizedby || "",
                            AuthorizedbyDate: data?.authorizedbyDate || "",
                            Closeddate :data?.bemscheduledworkorderheaders[0]?.bemscheduledwocompletiondetails?.[0]?.authorizeddate || "",
                            Closedid :data?.bemscheduledworkorderheaders[0]?.bemscheduledwocompletiondetails?.[0]?.authorizedbyid || "",
                            editmode: true,
                            // completedby : data?.bemscheduledworkorderheaders?.[0]?.completedby || "",
                            // completeddate : data?.bemscheduledworkorderheaders?.[0]?.completeddate || "",
                        };
                        
                        setBasicDetailsData(mappedData);
                        dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                        dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                        setLoading(false);
                    };
                } else {
                    const response = await workOrderSummaryRepositry.getWorkOrderSummary(editServiceType, location?.state?.id || hyperLinkDecryptData?.id, workorderCategoryType, workOrderType);
                    if (editServiceType === 'fem') {                        
                        const data = response?.[0];
                        const getRepairType = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype 
                        ? data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype : "Inhouse"
                        // : data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.femassetppmstatusId === 2
                        //     ? "Inhouse"
                        //     : data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.femassetppmstatusId === 1
                        //         ? "Outsource"
                        //         : "Inhouse"
                        const setvendorField = getRepairType === 'Outsource' ? true : false;
                        const status = data?.femunscheduledworkorderheaders?.[0]?.femworkorderstatus?.workorderstatus || "";
                        const percentageStatus = data?.femunscheduledworkorderheaders?.[0]?.processingpercentage || "";
                        const setProcessingPercentage = (status === statusList?.completed?.label || status === statusList?.completedOutsource?.label || status === statusList?.verified?.label) ? 92 : status === statusList?.closed?.label ? 100 : percentageStatus
                        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: setProcessingPercentage }))

                        const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                        const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                        const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();

                        const mapEmployeeIdToName = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeename : '';
                        };

                        const mapEmployeeIdTodesignation = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.designation : '';
                        };

                        const mapEmployeeIdToCode = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeecode : '';

                        };

                        const mapFlagIdToLabel = (id) => {
                            const flag = lovOptionsResponse?.femuschworepairflags.find(f => f?.id === id);
                            return flag ? flag?.repairflag : '';
                        };

                        const mapPicIdToLabel = (id) => {
                            const pic = lovOptionsResponse?.femuschworepairpics.find(p => p?.id === id);
                            return pic ? pic?.repairpic : '';
                        };

                        const mapActivityIdToLabel = (id) => {
                            const activity = lovOptionsResponse?.femuschworepairactivities.find(a => a?.id === id);
                            return activity ? activity?.repairactivity : '';
                        };

                        const maptoVendorDetails = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorname : '';
                        }

                        const maptoVendorCode = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorcode : '';
                        };

                        // Mapping repairTracker data
                        const repairTracker = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femunscheduledworepairdetails?.map((repairDetail) => {
                            return {
                                employeename: {
                                    id: repairDetail?.employeeid || "",
                                    employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                    employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                },
                                flag: {
                                    id: repairDetail?.femuschworepairflagId || '',
                                    label: mapFlagIdToLabel(repairDetail?.femuschworepairflagId) || ''
                                },
                                pic: {
                                    id: repairDetail?.femuschworepairpicId || '',
                                    label: mapPicIdToLabel(repairDetail?.femuschworepairpicId) || ''
                                },
                                activity: {
                                    id: repairDetail?.femuschworepairactivityId || '',
                                    label: mapActivityIdToLabel(repairDetail?.femuschworepairactivityId) || ''
                                },
                                startDateandTime: repairDetail?.repairstartdate || "",
                                endDateandTime: repairDetail?.repairenddate || "",
                                repairDuration: repairDetail?.repairduration || "",
                                remarks: repairDetail?.remarks || "",
                                preparationHours: repairDetail?.preparationhours || '',
                                verificationHours: repairDetail?.verificationhours || '',
                                id: repairDetail?.id || "",
                                technician: repairDetail?.vendortechnician || "",
                                timeStamp: repairDetail?.timestamp || ""
                            };
                        }) || [];

                        const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType, categoryType);

                        const mapItemCode = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.itemcode : '';
                        };

                        const maptoUnitCost = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.unitcost : '';
                        };

                        const mapItemDesc = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.descriptionname : '';
                        };

                        const partReplacement = data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwopartsreplacedetails?.map((partDetails) => {


                            return {
                                itemPartCode: {
                                    id: partDetails?.itemcodeid || "",
                                    label: mapItemCode(partDetails?.itemcodeid) || "",
                                    unitCost:maptoUnitCost(partDetails?.itemcodeid) || ""
                                },
                                itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                quantity: partDetails?.quantityused || "",
                                partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
                                id: partDetails?.id || "",
                                editmode: true,
                                timeStamp: partDetails?.timestamp || "",
                            };
                        }) || [];

                        const refworkreq = {
                            id: data?.femunscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheaderId || "",
                            label: data?.femunscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheader?.deptworkrequestno || "",
                        };

                        if (refworkreq?.id) {
                            setIsWorkRequestNoSelected(true);
                        };

                        const assetNo = {
                            id: data?.assetId || "",
                            label: data?.assetNo || "",
                            // repairType: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.femassetppmstatusId === 2
                            //     ? "Inhouse"
                            //     : data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.femassetppmstatusId === 1
                            //         ? "Outsource"
                            //         : "Inhouse",
                            repairType:"Inhouse",
                            workGroupId:data?.wgId || "",
                        };

                        const assetTakenLocation = {
                            id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 1
                                : data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 2
                                    : "",
                            label: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 'Yes'
                                : data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 'No'
                                    : ""
                        };

                        const partsRequired = {
                            id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 1
                                : data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 2
                                    : "",
                            label: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 'Yes'
                                : data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 'No'
                                    : ""
                        };

                        const withPartsRequired = getStepper;
                        const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                        if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                            dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                        } else {
                            dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                        };

                        const compRespondedBy = {
                            id: "",
                            label: "",
                            designation: ""

                        };

                        const vendor = {
                            id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "",
                            label: maptoVendorDetails(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid) || '',
                            vendorcode: maptoVendorCode(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                        }

                        const respondedBy = {
                            id: data?.assessmentEmployeeId || "",
                            label: data?.assessmentEmployeename || ""
                        };

                        const taskcode = {
                            id: data?.taskcodeId || "",
                            label: data?.taskcode || ""
                        };

                        const mappedData = {
                            id: location?.state?.id || hyperLinkDecryptData?.id || "",
                            serviceType: editServiceType || "",
                            workOrderNo: data?.workorderno || '',
                            referenceWorkRequestNo: refworkreq || "",
                            issueDateandTimeBasicDetails: data?.femunscheduledworkorderheaders?.[0]?.targetdate || "",
                            workorderDateandTime: data?.workorderdate || "",
                            requestor: data?.femunscheduledworkorderheaders?.[0]?.requestor || '',
                            designation: data?.femunscheduledworkorderheaders?.[0]?.designation || '',
                            contactNo: data?.femunscheduledworkorderheaders?.[0]?.contactno || '',
                            assetNo: assetNo || [],
                            oldAssetNo: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.oldassetNo || '',
                            description: data?.assetDescription || '',
                            underwarrenty: data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.isunderwarranty === true
                                ? "Yes"
                                : data?.femunscheduledworkorderheaders?.[0]?.femassetregister?.isunderwarranty === false
                                    ? "No"
                                    : '',
                            location: data?.locationdesc || '',
                            workGroupId: data?.wgId || "",
                            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                            requestDetails: data?.femunscheduledworkorderheaders?.[0]?.requestdetails || '',
                            recivedDateandTime: data?.femunscheduledworkorderheaders?.[0]?.receiveddate || "",
                            category: {
                                label: data?.workordercategory || "",
                                isvisible: true,
                                id: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.femworkordercategoryId || ""
                            },
                            type: {
                                label: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.workordertype || "",
                                isvisible: true,
                                id: data?.femunscheduledworkorderheaders?.[0]?.femworkordertype?.id || ""
                            },
                            priority: {
                                label: data?.femunscheduledworkorderheaders?.[0]?.femworkorderpriority?.workorderpriority || "",
                                isvisible: true,
                                id: data?.femunscheduledworkorderheaders?.[0]?.femworkorderpriority?.id || ""
                            },
                            targetResponse: data?.femunscheduledworkorderheaders?.[0]?.femwotargetresponse?.targetresponse || "",
                            cancelledBy: data?.femunscheduledworkorderheaders?.[0]?.cancelledby || '',
                            reasonforCancellation: data?.femunscheduledworkorderheaders?.[0]?.cancellationreason || '',
                            completionInfo: {
                                id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.id || '',
                                respondedBy: compRespondedBy || '',
                                designation: data?.completionDesignation || '',
                                respondedDateandTime: data?.femunscheduledworepairdetails?.[0]?.femunscheduledwoassessmentheader?.[0]?.responsestartdate || "",
                                duration: data?.duration || '',
                                completionBy: {
                                    id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                    label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                    value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                },
                                startDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.startdate || '',
                                endDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.enddate || '',
                                actionTaken: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                signatureFiles: [],
                                timeStamp: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.timestamp || '',
                                costInfo: {
                                    editmode: true,
                                    breakDownCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                    poNumber: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                                    ppmCostByPurchaseOrder: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                    poNumberByPurchaseOrder: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                                    ppmCostByContract: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                    contractReferenceNumber: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractrefno || '',
                                    totalSparePartCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                    totalWorkorderCost: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0
                                }
                            },
                            assessments: {
                                id: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.id || '',
                                respondedBy: respondedBy || '',
                                designation: data?.assessmentDesignation || "",
                                respondedStartDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
                                respondedEndDateandTime: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responseenddate || '',
                                taskCode: taskcode || '',
                                taskDescription: data?.taskdesc || '',
                                repairType:getRepairType || data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype || '',
                                partsRequired: partsRequired || '',
                                assetTakenLocation: assetTakenLocation || '',
                                respondedFinding: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                repairTracker: repairTracker || [],
                                timeStamp: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.timestamp || "",
                                vendor: vendor || "",
                                outsourceRespondRemarks: data?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                            },
                            partReplacementRows: partReplacement,
                            editmode: true,
                            Authorizedby: data?.authorizedby || "",
                            AuthorizedbyDate: data?.authorizedbyDate || "",
                            timeStamp: location?.state?.timestamp || "",
                            Closeddate :data?.femunscheduledworkorderheaders[0]?.femunscheduledwocompletiondetails?.[0]?.authorizeddate || "",
                            Closedid :data?.femunscheduledworkorderheaders[0]?.femunscheduledwocompletiondetails?.[0]?.authorizedbyid || "",
                            isAutoAssign: data?.femunscheduledworkorderheaders?.[0]?.isautoassign || "",
                            isTransfer:data?.femunscheduledworkorderheaders?.[0]?.istransfer || "",
                            transfertoId: data?.femunscheduledworkorderheaders?.[0]?.transfertoid || "",
                            transferto : data?.transferto || "",
                            // completedby : data?.femunscheduledworkorderheaders?.[0]?.completedby || "",
                            // completeddate : data?.femunscheduledworkorderheaders?.[0]?.completeddate || "",
                        };

                        setBasicDetailsData(mappedData);
                        dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                        dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                        setLoading(false);
                    } else {
                        const data = response?.[0];
                        const getRepairType = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype 
                        ? data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype : "Inhouse"
                        // : data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.bemassetppmstatusId === 2
                        //     ? "Inhouse"
                        //     : data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.bemassetppmstatusId === 1
                        //         ? "Outsource"
                        //         : "Inhouse"
                        const setvendorField = getRepairType === 'Outsource' ? true : false;
                        const status = data?.bemunscheduledworkorderheaders?.[0]?.bemworkorderstatus?.workorderstatus || "";
                        const percentageStatus = data?.bemunscheduledworkorderheaders?.[0]?.processingpercentage || "";
                        const setProcessingPercentage = (status === statusList?.completed?.label || status === statusList?.completedOutsource?.label || status === statusList?.verified?.label) ? 92 : status === statusList?.closed?.label ? 100 : percentageStatus
                        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: setProcessingPercentage }))

                        const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                        const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                        const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
                        const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType, categoryType);

                        const mapEmployeeIdToName = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeename : '';
                        };

                        const mapEmployeeIdTodesignation = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.designation : '';
                        };

                        const mapEmployeeIdToCode = (id) => {
                            const employee = employeeResponse?.find(emp => emp?.id === id);
                            return employee ? employee?.employeecode : '';

                        };


                        const mapFlagIdToLabel = (id) => {
                            const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
                            return flag ? flag?.repairflag : '';
                        };

                        const mapPicIdToLabel = (id) => {
                            const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
                            return pic ? pic?.repairpic : '';
                        };

                        const mapActivityIdToLabel = (id) => {
                            const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
                            return activity ? activity?.repairactivity : '';
                        };

                        const maptoVendorDetails = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorname : '';
                        };

                        const maptoVendorCode = (id) => {
                            const vendor = vendorDetails?.find(v => v?.id === id);
                            return vendor ? vendor?.vendorcode : '';
                        };

                        const mapItemCode = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic.itemcode : '';
                        };

                        const maptoUnitCost = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.unitcost : '';
                        };

                        const mapItemDesc = (id) => {
                            const ic = itemCodeResponse?.find(ic => ic?.id === id);
                            return ic ? ic?.descriptionname : '';
                        };

                        // Mapping repairTracker data
                        const repairTracker = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemunscheduledworepairdetails?.map((repairDetail) => {
                            return {
                                employeename: {
                                    id: repairDetail?.employeeid || "",
                                    employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                    employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                },
                                flag: {
                                    id: repairDetail?.bemuschworepairflagId || '',
                                    label: mapFlagIdToLabel(repairDetail?.bemuschworepairflagId) || ''
                                },
                                pic: {
                                    id: repairDetail?.bemuschworepairpicId || '',
                                    label: mapPicIdToLabel(repairDetail?.bemuschworepairpicId) || ''
                                },
                                activity: {
                                    id: repairDetail?.bemuschworepairactivityId || '',
                                    label: mapActivityIdToLabel(repairDetail?.bemuschworepairactivityId) || ''
                                },
                                technician: repairDetail?.vendortechnician || "",
                                startDateandTime: repairDetail?.repairstartdate || "",
                                endDateandTime: repairDetail?.repairenddate || "",
                                repairDuration: repairDetail?.repairduration || "",
                                remarks: repairDetail?.remarks || '',
                                preparationHours: repairDetail?.preparationhours || '',
                                verificationHours: repairDetail?.verificationhours || '',
                                id: repairDetail?.id || "",
                                timeStamp: repairDetail?.timestamp || ""
                            };
                        }) || [];

                        const partReplacement = data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwopartsreplacedetails?.map((partDetails) => {
                            return {
                                itemPartCode: {
                                    id: partDetails?.itemcodeid || "",
                                    label: mapItemCode(partDetails?.itemcodeid) || "",
                                    unitCost:maptoUnitCost(partDetails?.itemcodeid) || ""
                                },
                                itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                quantity: partDetails?.quantityused || "",
                                partCost: parseFloat(partDetails?.partscost || 0).toFixed(2) || "",
                                id: partDetails?.id || "",
                                editmode: true,
                                timeStamp: partDetails?.timestamp || "",
                            };
                        }) || [];

                        const refworkreq = {
                            id: data?.bemunscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheaderId || "",
                            label: data?.bemunscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheader?.deptworkrequestno || "",
                        };

                        if (refworkreq?.id) {
                            setIsWorkRequestNoSelected(true);
                        };

                        const assetNo = {
                            id: data?.assetId || "",
                            label: data?.assetNo || "",
                            // repairType: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.bemassetppmstatusId === 2
                            //     ? "Inhouse"
                            //     : data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.bemassetppmstatusId === 1
                            //         ? "Outsource"
                            //         : "Inhouse",
                            repairType:"Inhouse",
                            workGroupId:data?.wgId || "",

                        };

                        const respondedBy = {
                            id: data?.assessmentEmployeeId || "",
                            label: data?.assessmentEmployeename || ""
                        };

                        const taskcode = {
                            id: data?.taskcodeId || "",
                            label: data?.taskcode || ""
                        };

                        const partsRequired = {
                            id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 1
                                : data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 2
                                    : "",
                            label: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                ? 'Yes'
                                : data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                    ? 'No'
                                    : ""
                        };

                        const withPartsRequired = getStepper;
                        const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                        if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                            dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                        } else {
                            dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                        };


                        const assetTakenLocation = {
                            id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 1
                                : data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 2
                                    : "",
                            label: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                ? 'Yes'
                                : data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                    ? 'No'
                                    : ""
                        };


                        const compRespondedBy = {
                            id: data?.completionEmployeeId || "",
                            label: data?.completionEmployeename || "",
                            designation: mapEmployeeIdTodesignation(data?.completionEmployeeId) || ""
                        };

                        const vendor = {
                            id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "",
                            label: maptoVendorDetails(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid) || '',
                            vendorcode: maptoVendorCode(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                        }

                        const mappedData = {
                            id: location?.state?.id || hyperLinkDecryptData?.id || "",
                            serviceType: editServiceType || "",
                            workOrderNo: data?.workorderno || '',
                            referenceWorkRequestNo: refworkreq || "",
                            issueDateandTimeBasicDetails: data?.bemunscheduledworkorderheaders?.[0]?.targetdate || "",
                            workorderDateandTime: data?.workorderdate || "",
                            requestor: data?.bemunscheduledworkorderheaders?.[0]?.requestor || '',
                            designation: data?.bemunscheduledworkorderheaders?.[0]?.designation || '',
                            contactNo: data?.bemunscheduledworkorderheaders?.[0]?.contactno || '',
                            assetNo: assetNo || [],
                            oldAssetNo: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.oldassetNo || '',
                            description: data?.assetDescription || '',
                            underwarrenty: data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === true
                                ? "Yes"
                                : data?.bemunscheduledworkorderheaders?.[0]?.bemassetregister?.isunderwarranty === false
                                    ? "No"
                                    : '',
                            location: data?.locationdesc  || '',
                            workGroupId: data?.wgId || "",
                            workgroupDescription: `${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                            requestDetails: data?.bemunscheduledworkorderheaders?.[0]?.requestdetails || '',
                            recivedDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.receiveddate || "",
                            category: {
                                label: data?.workordercategory || "",
                                isvisible: true,
                                id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.bemworkordercategoryId || ""
                            },
                            type: {
                                label: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
                                isvisible: true,
                                id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.id || ""
                            },
                            priority: {
                                label: data?.bemunscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority || "",
                                isvisible: true,
                                id: data?.bemunscheduledworkorderheaders?.[0]?.bemworkorderpriority?.id || ""
                            },
                            targetResponse: data?.bemunscheduledworkorderheaders?.[0]?.bemwotargetresponse?.targetresponse || "",
                            cancelledBy: data?.bemunscheduledworkorderheaders?.[0]?.cancelledby || '',
                            reasonforCancellation: data?.bemunscheduledworkorderheaders?.[0]?.cancellationreason || '',
                            completionInfo: {
                                id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.id || '',
                                respondedBy: compRespondedBy || '',
                                designation: data?.completionDesignation || '',
                                respondedDateandTime: data?.bemunscheduledworepairdetails?.[0]?.bemunscheduledwoassessmentheader[0]?.responsestartdate || "",
                                duration: data?.duration || '',
                                completionBy: {
                                    id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                    label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                    value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                },
                                startDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.startdate || '',
                                endDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.enddate || '',
                                actionTaken: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                signatureFiles: [],
                                timeStamp: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.timestamp || '',
                                costInfo: {
                                    editmode: true,
                                    breakDownCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                    poNumber: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                                    ppmCostByPurchaseOrder: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                    poNumberByPurchaseOrder: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                                    ppmCostByContract: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                    contractReferenceNumber: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractrefno || '',
                                    totalSparePartCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                    totalWorkorderCost: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0
                                }
                            },
                            assessments: {
                                id: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.id || '',
                                respondedBy: respondedBy || '',
                                designation: data?.assessmentDesignation,
                                respondedStartDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
                                respondedEndDateandTime: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responseenddate || '',
                                taskCode: taskcode || '',
                                taskDescription: data?.taskdesc || '',
                                repairType: getRepairType || data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype || '',
                                partsRequired: partsRequired || '',
                                assetTakenLocation: assetTakenLocation || '',
                                respondedFinding: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                repairTracker: repairTracker || [],
                                timeStamp: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.timestamp || "",
                                vendor: vendor || "",
                                outsourceRespondRemarks: data?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                            },
                            partReplacementRows: partReplacement,
                            editmode: true,
                            Authorizedby: data?.authorizedby || "",
                            AuthorizedbyDate: data?.authorizedbyDate || "",
                            timeStamp: location?.state?.timestamp || '',
                            Closeddate :data?.bemunscheduledworkorderheaders[0]?.bemunscheduledwocompletiondetails?.[0]?.authorizeddate || "",
                            Closedid :data?.bemunscheduledworkorderheaders[0]?.bemunscheduledwocompletiondetails?.[0]?.authorizedbyid || "",
                            isAutoAssign: data?.bemunscheduledworkorderheaders?.[0]?.isautoassign || "",
                            isTransfer:data?.bemunscheduledworkorderheaders?.[0]?.istransfer || "",
                            transfertoId: data?.bemunscheduledworkorderheaders?.[0]?.transfertoid || "",
                            transferto : data?.transferto || "",
                            // completedby : data?.bemunscheduledworkorderheaders?.[0]?.completedby || "",
                            // completeddate : data?.bemunscheduledworkorderheaders?.[0]?.completeddate || "",
                        };
                        setBasicDetailsData(mappedData);
                        dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                        dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                        setLoading(false);
                    };
                };
            };               
        } catch (error) {
            console.error("Error fetching data:", error);
        }

       
    };
    
    useEffect(() => {
        async function initializeData() {
            setLoading(true);
                await Promise.all([
                    assetNoOptions(),
                    workrequestNoOptions(),
                    categoryandPriorityOptions(),
                    fetchTypes(),
                ]);
           
            if (basicDetailsdata?.referenceWorkRequestNo?.id) {
                setIsWorkRequestNoSelected(true);
            }
    
            const stateData = location?.state;
            
            if (stateData?.deptid) {
                const workrequest = stateData.deptid;
                const isButtonChanged = stateData.buttonchange === "1";
                const assetDetails = stateData.assetDetails || {};
                const warranty = assetDetails.isunderwarranty === true ? "Yes" : 
                                 assetDetails.isunderwarranty === false ? "No" : "";
    
                const mappedData = {
                    referenceWorkRequestNo: {
                        id: isButtonChanged ? (stateData.afterUpdateId || workrequest?.id) : workrequest?.id || "",
                        label: workrequest?.deptworkrequestno || "",
                        serviceId: assetDetails?.serviceId || workrequest?.serviceId || "",
                        serviceName: assetDetails?.service || workrequest?.service || "",
                    },
                    issueDateandTimeBasicDetails: workrequest?.deptworkrequestdate || "",
                    requestor: stateData.requestor || workrequest?.requestor || "",
                    designation: stateData.designation || workrequest?.designation || "",
                    contactNo: stateData.contactno || workrequest?.contactno || "",
                    assetNo: {
                        label: assetDetails?.assetno || workrequest?.assetno?.label || "",
                        id: assetDetails?.id || workrequest?.assetno?.value || "",
                        repairType: assetDetails?.repairType || workrequest?.repairType || "Inhouse",
                    },
                    oldAssetNo: assetDetails?.oldAssetno || workrequest?.oldAssetno || "",
                    requestDetails: stateData.requestdetails || workrequest?.requestdetails || "",
                    location: assetDetails?.location || workrequest?.locationName || "",
                    description: assetDetails?.descrption || workrequest?.assetdesc || "",
                    workgroupDescription: assetDetails?.workGroup || workrequest?.workcode || "",
                    category: { label: workrequest?.categoryId?.label || "", id: workrequest?.categoryId?.value || "" },
                    type: { label: workrequest?.typeId?.label || "", id: workrequest?.typeId?.value || "" },
                    underwarrenty: warranty,
                    workGroupId: assetDetails?.workGroupId || workrequest?.workGroupId || "",
                    priority: { label: workrequest?.criticality || "", id: workrequest?.criticalityId || "" },
                };
    
                setBasicDetailsData((prev) => ({ ...prev, ...mappedData }));
                setIsWorkRequestNoSelected(true);
            }

            if(location?.state?.isCreateMode){                
                setLoading(false);
            }        
        }
        initializeData();
        getDecryptData()
    }, []);

    useEffect(() => {
        const fetchAssetNo = async () => {
            await assetNoOptions();
        }
        fetchAssetNo();

        if (basicDetails?.id) {            
            setBasicDetailsData(basicDetails);
        } else if(location?.state?.isCreateMode) {            
            setBasicDetailsData((prev) => ({
                ...prev,
                workorderDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                recivedDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
            }));
        }

    }, [basicDetailsdata?.referenceWorkRequestNo, location?.state?.editmode])

console.log(hyperLinkDecryptData,"hyperLinkDecryptData");

    useEffect(()=>{
        fetchData();
    },[checkIsHyperLink ? hyperLinkDecryptData : ""])
    // },[checkIsHyperLink ? hyperLinkDecryptData : "",basicDetails?.editmode])

    const commonSubmitFunction = async () => {
        const isValid = handleValidationForRequiredFields();

        if (isValid) {            
            setLoading(true);
            let commonSubmitResponse = null;
            const API_Payload = {
                workorderno: basicDetailsdata?.workOrderNo || basicDetails?.workOrderNo || "",
                workorderdate: basicDetailsdata?.workorderDateandTime ||"",
                targetdate: categoryType === "Scheduled" ?
                    basicDetailsdata?.issueDateandTimeBasicDetails : (basicDetailsdata?.issueDateandTimeBasicDetails
                        ? basicDetailsdata?.issueDateandTimeBasicDetails : basicDetailsdata?.workorderDateandTime),
                requestor: basicDetailsdata?.requestor || "",
                designation: basicDetailsdata?.designation || "",
                receiveddate: basicDetailsdata?.recivedDateandTime || "",
                contactno: basicDetailsdata?.contactNo || "",
                requestdetails: basicDetailsdata?.requestDetails || "",
                receivedbyid: basicDetailsdata?.receivedbyid || "",
                cancelledby: basicDetailsdata?.cancelledBy || "",
                cancellationreason: basicDetailsdata?.reasonforCancellation || "",
                isppmused: basicDetailsdata?.isppmused || false,
                [`${serviceType}assetregisterId`]: basicDetailsdata?.assetNo?.id || "",
                [`${serviceType}workorderstatusId`]: basicDetails?.editmode ? mappedStatus : 1 || "", //1 for  open status id while creating the work order
                [`${serviceType}workordertypeId`]: basicDetailsdata?.type?.id || 1,
                [`${serviceType}workorderpriorityId`]: basicDetailsdata?.priority?.id || "",
                [`${serviceType}workordersafetyperformtestId`]: basicDetailsdata?.femworkordersafetyperformtestId || "",
                [`${serviceType}wotargetresponseId`]: basicDetailsdata?.priority?.id || "",
                completeddate: basicDetailsdata?.completeddate || "",
                [`${serviceType}departmentworkrequestheaderId`]: basicDetailsdata?.referenceWorkRequestNo?.id || "",
                [`${serviceType}ppmscheduletrackId`]: basicDetails?.ppmscheduletrackId || "",
                [`${serviceType}predictivemaintenancetrackId`]: basicDetails?.pdmscheduletrackId || "",
                id: basicDetailsdata?.id || basicDetails?.id || "",
                Processingpercentage: basicDetails?.editmode ? processingPercentage : 16 || "", //16 for processing percentage while creating the work order
                timestamp: basicDetails?.timeStamp || "",
                facilityid: facilityId || "",
                token: token || "",
                isverify: location?.state?.isverify === "Yes" ? 1 : "" || hyperLinkDecryptData.isverify === "Yes" ? 1 : "" || "",
                performancetest: basicDetails?.performancetest || "",
                electricalsafteytest: basicDetails?.electricalsafteytest || "",
                processstatus: basicDetails?.processstatus || "",
                isautoassign: confirmationAutoAsign ? true : basicDetails?.isAutoAssign,
                isautoassignaccept:!confirmationAutoAsign ? true :  basicDetails?.id ? true : false,
                istransfer: basicDetails?.isTransfer || basicDetailsdata?.isTransfer || false,
                transfertoid: basicDetails?.transfertoId || basicDetailsdata?.transfertoId || "",
                // completeddate: basicDetails?.completeddate || basicDetailsdata?.completeddate ||"",
                // completedby: basicDetails?.completedby || "",
            };            

            const workRequest_Payload = {
                id: basicDetailsdata?.referenceWorkRequestNo?.id || "",
                requestor: basicDetailsdata?.referenceWorkRequestNo?.requestor || basicDetailsdata?.requestor || "",
                designation: basicDetailsdata?.referenceWorkRequestNo?.designation || basicDetailsdata?.designation || "",
                contactno: basicDetailsdata?.referenceWorkRequestNo?.contactNo || basicDetailsdata?.contactNo || "",
                requestdetails: basicDetailsdata?.requestDetails || "",
                typeId: basicDetailsdata?.referenceWorkRequestNo?.type?.id || basicDetailsdata?.type?.id || 1,
                [`${serviceType}assetregisterId`]: basicDetailsdata?.assetNo?.id || ""
            };

            if (basicDetails?.id) {                
                const updateWorkOrderResponse = await workOrderSummaryRepositry.updateBasicDetails(serviceType, API_Payload, categoryType);
                if (basicDetailsdata?.referenceWorkRequestNo?.id) {
                    await workOrderSummaryRepositry.updateWorkRequestNO(serviceType, workRequest_Payload, categoryType)
                }
                commonSubmitResponse = updateWorkOrderResponse?.id;
                if (updateWorkOrderResponse?.id) {
                    setPageNavigate(true);
                    // dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: updateWorkOrderResponse?.id, workOrderNo: updateWorkOrderResponse?.workorderno, isAutoAssign: updateWorkOrderResponse?.isautoassign, isverify: location?.state?.isverify || hyperLinkDecryptData.isverify==="Yes" ? 1 :"" || "", isresponse: location?.state?.isresponse || hyperLinkDecryptData.isresponse || ""}));
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: updateWorkOrderResponse?.id, workOrderNo: updateWorkOrderResponse?.workorderno, isAutoAssign: updateWorkOrderResponse?.isautoassign, isverify: location?.state?.isverify || "", isresponse: location?.state?.isresponse || "",isAutoAssignAccepted:updateWorkOrderResponse?.isAutoAssignAccepted || "" }));
                } else if (updateWorkOrderResponse?.response?.data?.status >= 405) {
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }
            }
            else {
                const createWorkOrderResponse = await workOrderSummaryRepositry.createBasicDetails(serviceType, API_Payload, categoryType);
                if (basicDetailsdata?.referenceWorkRequestNo?.id) {
                    await workOrderSummaryRepositry.updateWorkRequestNO(serviceType, workRequest_Payload, categoryType)
                }
                commonSubmitResponse = createWorkOrderResponse?.id;
                if (createWorkOrderResponse?.response?.data?.status === 400) {
                    setErrorDialog(true);
                    setErrorDialogMssg(basicDetailsdata?.referenceWorkRequestNo?.id ? `${basicDetailsdata?.referenceWorkRequestNo?.label || ""} is already in use. Converted as Work Order.` : createWorkOrderResponse?.response?.data?.detail || "")
                };

                if (createWorkOrderResponse?.id) {
                    setPageNavigate(true);
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: createWorkOrderResponse?.id, workOrderNo: createWorkOrderResponse?.workorderno, isAutoAssign: createWorkOrderResponse?.isautoassign,isEditmode:true }));
                    dispatch(updateOutsourceDetails("SET_VENDORFIELD", basicDetailsdata?.assetNo?.repairType === 'Outsource' ? true : false));
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.open?.label, percentage: processingPercentageValue?.basicDetails }));
                    navigate(location?.pathname, {
                        state: {
                            ...location.state,
                            id: createWorkOrderResponse?.id || "",
                            category: assetCategoryType?.category || "",
                            service: serviceType || "",
                            workordertype: basicDetailsdata?.type?.label || "",
                            timestamp: createWorkOrderResponse?.timestamp || "",
                            editmode: true
                        }
                    });

                } else if (createWorkOrderResponse?.response?.data?.status >= 405) {
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }

            };
            setLoading(false);
            return !!commonSubmitResponse;
        };
        return false;
    };

    useEffect(() => {
        
        if (pageNavigate && !checkAutoAsign) {
            setLoading(true);
            setPage("Assessments");
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            setPageNavigate(false);
            setLoading(false)
        };

    }, [basicDetailsdata, basicDetails?.id, pageNavigate, checkAutoAsign]);


    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!viewmode && mappedStatus !== 6 && mappedStatus !== 7) {
            setLoading(true);
    
            if (mappedStatus === 1 && basicDetails?.id) {
                const id = basicDetails?.id || location?.state?.id || "";
                const API_Response = await workOrderSummaryRepositry.getByIdBasicdetails(serviceType, id, categoryType);    
                if (API_Response?.isautoassignaccept) {
                    await commonSubmitFunction();
                } else {
                    setCancelAutoAsign(true);
                    setLoading(false);
                    return;
                }
            } else {
                await commonSubmitFunction();
            };
    
            if (pageNavigate) {
                setPage("Assessments");
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            };
    
            setLoading(false);
        } else {
            setPage("Assessments");
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            setLoading(false);
        }
    };
        
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!viewmode && mappedStatus !==6 && mappedStatus !==7) {
    //         await commonSubmitFunction();
    //         if (pageNavigate) {
    //             setPage("Assessments");
    //             dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    //         };
    //         setLoading(false);
    //     } else {
    //         setPage("Assessments");
    //         dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    //     }
    // };

    const onEnabledChange = (name) => {
        if (name === "yes") {
            setEnable(true)
        }
        else if (name === "no") {
            setEnable(false)
        };
    };

    const handleConfirmCancelWO = async (updatedValues) => {
        setLoading(true);
        const isValid = handleValidationForRequiredFields();
        isValid ? (() => {
            onEnabledChange("yes");
            setBasicDetailsData((prev) => ({
                ...prev,
                cancelledBy: updatedValues.cancelledBy,
                reasonforCancellation: updatedValues.reasonforCancellation,
            }));
        })()
            : onEnabledChange("no");

        const cancelWorkOrderPayload = {
            workorderno: basicDetailsdata?.workOrderNo || "",
            workorderdate: basicDetailsdata?.workorderDateandTime || "",
            targetdate: categoryType === "Scheduled" ?
                basicDetailsdata?.workorderDateandTime : (basicDetailsdata?.issueDateandTimeBasicDetails
                    ? basicDetailsdata?.issueDateandTimeBasicDetails : basicDetailsdata?.workorderDateandTime),
            requestor: basicDetailsdata?.requestor || "",
            designation: basicDetailsdata?.designation || "",
            receiveddate: basicDetailsdata?.recivedDateandTime || "",
            contactno: basicDetailsdata?.contactNo || "",
            requestdetails: basicDetailsdata?.requestDetails || "",
            receivedbyid: basicDetailsdata?.receivedbyid || "",
            cancelledby: updatedValues?.cancelledBy || "",
            cancellationreason: updatedValues?.reasonforCancellation,
            isppmused: basicDetailsdata?.isppmused || false,
            [`${serviceType}assetregisterId`]: basicDetailsdata?.assetNo?.id || "",
            [`${serviceType}workorderstatusId`]: 6,//send ID for Cancel Workorder Status
            [`${serviceType}workordertypeId`]: basicDetailsdata?.type?.id || "",
            [`${serviceType}workorderpriorityId`]: basicDetailsdata?.priority?.id || "",
            [`${serviceType}workordersafetyperformtestId`]: basicDetailsdata?.femworkordersafetyperformtestId || "",
            [`${serviceType}wotargetresponseId`]: basicDetailsdata?.priority?.id || "",
            completeddate: basicDetailsdata?.completeddate || "",
            [`${serviceType}departmentworkrequestheaderId`]: basicDetailsdata?.referenceWorkRequestNo?.id || "",
            [`${serviceType}ppmscheduletrackId`]: basicDetails?.ppmscheduletrackId || "",
            id: basicDetailsdata?.id || "",
            Processingpercentage: processingPercentage || "",
            timestamp: basicDetails?.timeStamp || "",
            isverify: location?.state?.isverify === "Yes" ? 1 : "" ||  hyperLinkDecryptData.isverify ==="Yes" ? 1 :"" || "",
            performancetest: basicDetails?.performancetest || "",
            electricalsafteytest: basicDetails?.electricalsafteytest || "",
            processstatus: basicDetails?.processstatus || "",
            istransfer: basicDetails?.istransfer || basicDetailsdata?.istransfer || false,
            transfertoid: basicDetails?.transfertoId || basicDetailsdata?.transfertoId || "",
            // completeddate: basicDetails?.completeddate || basicDetailsdata?.completeddate || "",
            // completedby: basicDetails?.completedby || "",
        };

        if (isValid) {
            const cancelWorkOrder = await workOrderSummaryRepositry.updateBasicDetails(serviceType, cancelWorkOrderPayload, categoryType);
            if (cancelWorkOrder?.id) {
                dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: cancelWorkOrder?.id }));
                dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.cancelled?.label, percentage: processingPercentage }));
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            } else if (cancelWorkOrder?.response?.data?.status >= 405) {
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
            }
        };
        setLoading(false);
    };

    const handleConfirmforWOandAutoAsign = async () => {
        setLoading(true);
        const isValid = handleValidationForRequiredFields();
        if (isValid) {
            setLoading(true)
            const response = await commonSubmitFunction();
            setConfirmationAutoAsign(false);
            if (response) {
                setTimeout(() => {
                    setOpenAutoAsignDialog(true);
                }, 500);
            };

        };
        setLoading(false)
    };

    const handleConfirmCancelforAutoAsign = async () => {
        setLoading(true);
        const isValid = handleValidationForRequiredFields();
        if (isValid) {

            await commonSubmitFunction();
            setCancelAutoAsign(false);
            setPage("Assessments");
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            setLoading(false);
        };
        setLoading(false)
    };


    const handleOpenconfirmDialog = () => {
        const isValid = handleValidationForRequiredFields();
        if (isValid) {
            setCheckAutoAsign(true);
            setConfirmationAutoAsign(true);
        };
    };

    const handleCloseAutoasignDialog = () => {
        setOpenAutoAsignDialog(false);
    };

    const handleCloseErrRequestDialog = () => {
        setErrorDialog(false);
        setErrorDialogMssg("");
    };

    const handleCloseConfirmationAutoAssignDialog = () => {
        setConfirmationAutoAsign(false);
        setCheckAutoAsign(false);
    };

    const handleCloseCancelAutoAssignDialog = () => {
        setCancelAutoAsign(false);
    };

    const handleConfirmAutoAsign = (e) => {
        e.preventDefault();
        setOpenAutoAsignDialog(false);
    };

    const handleConfirmErrRequestDialog = (e) => {
        e.preventDefault();
        setErrorDialog(false);
        setErrorDialogMssg("")
    };

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const handleAssetClick = (rowData) => {
        setBasicDetailsData((prev) => ({
            ...prev,
            assetNo: { ...rowData, label: rowData?.assetNo ? rowData?.assetNo : '' },
            oldAssetNo: rowData?.oldAssetNo || "",
            underwarrenty: rowData?.underwarrenty || "",
            description: rowData?.assetdesc || "",
            location: rowData?.location || "",
            workgroupDescription: rowData?.workGroupcodeDesc || "",
            workGroupId: rowData?.workGroupId || "",
            priority: { id: rowData.priorityId, label: rowData.priorityName }
        }));

        setError((prev) => ({
            ...prev,
            assetNo: false

        }));

        setErrorMessage((prev) => ({
            ...prev,
            assetNo: ''
        }));

        // Close the modal after asset selection
        handleCloseModal();
    };

    const columns = [
        {
            headerName: 'Asset No',
            field: 'assetNo',
            width: 150,
            cellRenderer: (params) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleAssetClick(params.data);
                    }}
                    style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                    }}
                >
                    {params.value}
                </a>
            ),
        },
        { headerName: 'Description', field: 'assetdesc', width: 200 },
        { headerName: 'Service', field: 'serviceName', width: 100 },
        { headerName: 'Old Asset No', field: 'oldAssetNo', width: 150 },
        { headerName: 'Under Warranty', field: 'underwarrenty', width: 150 },
        { headerName: 'Location Code', field: 'locationCode', width: 150 },
        { headerName: 'Location Desc', field: 'location', width: 150 },
        { headerName: 'Work Group & Description', field: 'workGroupcodeDesc', width: 150 }

    ];

    const formatDate = (dateString) => {
    
        if (!dateString) return ""; // Handle empty or undefined dates
        const date = new Date(dateString);
    
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
    
        const formattedDate = `${day}/${month}/${year}`;
    
        return formattedDate; // Formats to DD/MM/YYYY
    };
    


    return (

        <>
            <PageLoader open={loading} />
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
                requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
            />

            <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                <form style={{ position: "relative" }} noValidate>
                {/* <form style={{ position: "relative" }} onSubmit={(e) => handleSubmit(e)} noValidate> */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Work Order No(Auto)"
                                id="workOrderNo"
                                name="workOrderNo"
                                value={basicDetails?.workOrderNo || basicDetailsdata?.workOrderNo || ""}
                                onChange={handleOnchange}
                                disabled={true}
                            />
                        </Grid>

                        {!setScheduledField && (
                            <>
                                <Grid item xs={12} md={4} sm={6}>
                                    <CustomTextFieldWithSearch
                                        label="Reference/Work Request No"
                                        id="referenceNo"
                                        name="referenceWorkRequestNo"
                                        value={basicDetailsdata?.referenceWorkRequestNo || ""}
                                        onChange={handleOnchange}
                                        options={basicDetailsOptions?.workRequestNo || []}
                                        autoFocus={true}
                                        disabled={viewmode || mappedStatus === 6 || mappedStatus ===7 || basicDetails?.id ? true : false}
                                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || basicDetails?.id ? true : false} autoFocus
                                    />
                                </Grid>

                                <Grid item xs={6} md={4} sm={6}>
                                    <CustomDateTimePicker
                                        label="Issue Date and Time"
                                        value={basicDetailsdata?.issueDateandTimeBasicDetails || ""}
                                        onDateChange={(e) => handleOnchange(e, "issueDateandTimeBasicDetails")}
                                       // disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                        disabled={isWorkRequestNoSelected || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || mappedStatus ===7|| mappedStatus ===3|| mappedStatus ===10|| mappedStatus ===9}
                                        isRefilByOtherField={false}
                                        disableFutureDate={false}
                                        displayDefaultValue={false}

                                    />
                                </Grid>
                            </>
                        )}
                        <Grid item xs={6} md={4} sm={6}>
                            <CustomDateTimePicker
                                label="Work Order Date and Time"
                                value={basicDetailsdata?.workorderDateandTime || ""}
                                onDateChange={(e) => handleOnchange(e, "workorderDateandTime")}
                                helperText={errorMessage?.workorderDateandTime}
                                error={error?.workorderDateandTime}
                                isMandatoryField={true}
                                disableFutureDate={false}
                                // disabled={viewmode || mappedStatus === 6}
                                disabled={true}
                                displayDefaultValue={(location?.state?.editmode || hyperLinkDecryptData?.editmode ) ? false : true}

                            />
                        </Grid>

                        { setScheduledField && (
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomDatePicker
                                    label="Target Date"
                                    value={formatDate(basicDetailsdata?.issueDateandTimeBasicDetails) || ""} 
                                    onDateChange={(e) => handleOnchange(e, "issueDateandTimeBasicDetails")}
                                    disableFutureDate={false}
                                    disabled={true}
                                />
                            </Grid>
                        )}

                        {!setScheduledField && (
                            <>
                                <Grid item xs={12} md={4} sm={6}>
                                    <CustomTextField
                                        label="Requestor"
                                        id="requestor"
                                        name="requestor"
                                        value={basicDetailsdata?.requestor || ""}
                                        onChange={(e) => handleOnchange(e, "requestor", "Requestor")}
                                        error={error?.requestor}
                                        errorMessage={errorMessage?.requestor}
                                        isMandatoryField={true}
                                        disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                        // disabled={isWorkRequestNoSelected || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                                        maxlength={60}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} sm={6}>
                                    <CustomTextField
                                        label="Designation"
                                        id="designation"
                                        name="designation"
                                        value={basicDetailsdata?.designation || ""}
                                        onChange={handleOnchange}
                                        error={error?.designation}
                                        errorMessage={errorMessage?.designation}
                                        disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                        // disabled={isWorkRequestNoSelected || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                                        maxlength={60}
                                    />
                                </Grid>
                            </>


                        )}

                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Contact No."
                                id="contactNo"
                                name="contactNo"
                                value={basicDetailsdata?.contactNo || ""}
                                onChange={handleOnchange}
                                maxlength={20}
                                disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                            // disabled={isWorkRequestNoSelected || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                            />
                        </Grid>
                        {/* <Grid item xs={(viewmode) ? 12 : 11.5} md={(viewmode) ? 4 : 3.5} sm={(viewmode) ? 6 : 5.5}> */}
                            <Grid item xs={(viewmode || setScheduledField) ? 12 : 11.5} md={(viewmode || setScheduledField) ? 4 : 3.5} sm={(viewmode || setScheduledField) ? 6 : 5.5}>
                            <CustomTextFieldWithSearch
                                label="Asset No."
                                id="assetno"
                                name="assetNo"
                                value={basicDetailsdata?.assetNo || ""}
                                onChange={handleOnchange}
                                error={error?.assetNo}
                                isMandatoryField={!setScheduledField ? true : false}
                                options={basicDetailsOptions?.assetNo || []}
                                errorMessage={errorMessage?.assetNo}
                                hideSearch={true}
                                disabled={viewmode || mappedStatus === 6 || mappedStatus ===7 || mappedStatus === 5 || mappedStatus === 4 || setScheduledField}
                            // disabled={ viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || setScheduledField}
                            />
                        </Grid>

                        {/* {(!viewmode) && (<Grid item xs={0.5} md={0.5} sm={0.5} > */}
                            {(!viewmode && !setScheduledField)  && (<Grid item xs={0.5} md={0.5} sm={0.5} >

                            {!viewmode && (
                                <Grid sx={{ mt: 2.7 }} item>
                                    <Button
                                        onClick={handleOpenModal}
                                        variant="contained"
                                        sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                                        disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus ===7 }>
                                        {/* disabled={ viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}> */}
                                        <SearchIcon fontSize="small" />
                                    </Button>
                                </Grid>
                            )}

                            <Dialog
                                open={isModalOpen}
                                onClose={(event, reason) => {
                                    if (reason === "backdropClick") {
                                        return; // Prevent closing on backdrop click
                                    }
                                    handleCloseModal(); // Call the close function for other reasons
                                }}
                                // onClose={handleCloseModal}
                                aria-labelledby="asset-grid-dialog"
                                aria-describedby="grid-display-for-assets"
                                maxWidth="lg"
                                fullWidth
                            ><DialogTitle
                                id="asset-grid-dialog"
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: '1.5rem', // Adjust font size as desired
                                    display: 'flex',
                                    justifyContent: 'space-between', // Space out title and icon
                                    alignItems: 'center',
                                }}
                            >
                                    Asset Search
                                    <IconButton
                                        aria-label="close"
                                        variant="outlined"
                                        onClick={handleCloseModal}
                                        sx={{
                                            color: (theme) => theme.palette.grey[500],
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent
                                    dividers
                                    sx={{
                                        overflowY: 'auto', // Enables scroll if content overflows
                                        height: 'auto',    // Allows height to adjust based on content
                                        maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                                    }}
                                >
                                    <CustomAgGrid
                                        rows={basicDetailsOptions?.assetNo || []}
                                        columns={columns}
                                        // loading={loadingAssets}
                                        refSet={gridApi}
                                        setGridApi={setGridApi}
                                    />
                                    <Stack my={3} direction={"row"} justifyContent={"end"}>
                                        <Button variant="outlined" onClick={handleCloseModal}>
                                            Close
                                        </Button>
                                    </Stack>
                                </DialogContent>
                            </Dialog>

                        </Grid>)}

                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Old Asset No."
                                id="oldAssetNo"
                                name="oldAssetNo"
                                value={basicDetailsdata?.oldAssetNo || ""}
                                onChange={handleOnchange}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Description"
                                id="description"
                                name="description"
                                value={basicDetailsdata?.description || ""}
                                onChange={handleOnchange}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Under Warranty"
                                id="underwarrenty"
                                name="underwarrenty"
                                value={basicDetailsdata?.underwarrenty || ""}
                                onChange={handleOnchange}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Location"
                                id="location"
                                name="location"
                                value={basicDetailsdata?.location || ""}
                                onChange={handleOnchange}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Work Group & Description"
                                id="workgroupDescription"
                                name="workgroupDescription"
                                value={basicDetailsdata?.workgroupDescription || ""}
                                onChange={handleOnchange}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' > Request details </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8} sm={8}>
                                <CustomTextArea
                                    label="Request Details"
                                    id="requestDetails"
                                    value={basicDetailsdata?.requestDetails || ""}
                                    onChange={(e) => handleOnchange(e, "requestDetails", "Request Details")}
                                    error={error?.requestDetails}
                                    isMandatoryField={(setScheduledField && checkWorkOrderType) ? false : true}
                                    helperText={errorMessage?.requestDetails}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                    // disabled={ viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                                    maxLength={255}
                                />
                            </Grid>
                        </Grid>
                    </Box>


                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' >Work Order Receipt and Classification</Typography>
                        <Grid container spacing={2}>

                            {!setScheduledField && (
                                <>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomDateTimePicker
                                            label="Received Date and Time"
                                            value={basicDetailsdata?.recivedDateandTime || null}
                                            onDateChange={(e) => handleOnchange(e, "recivedDateandTime")}
                                            isMandatoryField={true}
                                            error={error?.recivedDateandTime}
                                            helperText={errorMessage?.recivedDateandTime}
                                            disableFutureDate={false}
                                            disabled={true}
                                           // disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                         //disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8|| mappedStatus === 6}
                                        />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    label="Category"
                                    id="Category"
                                    name="category"
                                    onChange={handleOnchange}
                                    value={basicDetailsdata?.category || ""}
                                    options={basicDetailsOptions?.category || []}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    label="Type"
                                    id="type"
                                    name="type"
                                    options={basicDetailsOptions?.type || []}
                                    value={basicDetailsdata?.type || []}
                                    onChange={handleOnchange}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus ===7 || setScheduledField || basicDetails?.type?.id === 10 ? true : false}
                                // disabled={isWorkRequestNoSelected || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || setScheduledField}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    label="Priority"
                                    id="priority"
                                    name="priority"
                                    value={basicDetailsdata?.priority || []}
                                    onChange={handleOnchange}
                                    options={basicDetailsOptions?.priority || []}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus ===7}
                                // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                                />
                            </Grid>

                            {!setScheduledField && (
                                <>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomTextField
                                            label="Target Response"
                                            id="targetResponse"
                                            name="targetResponse"
                                            value={basicDetailsdata?.targetResponse || ""}
                                            onChange={handleOnchange}
                                            disabled={true}
                                        />
                                    </Grid>
                                </>
                            )}



                            {checkcancelWOStatus && (
                                <>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomTextField
                                            label="Cancelled By"
                                            id="cancelledBy"
                                            name="cancelledBy"
                                            value={basicDetailsdata?.cancelledBy || ""}
                                            onChange={handleOnchange}
                                            // disabled={viewmode || mappedStatus === 6}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} sm={6}>
                                    <CustomTextArea
                                        label="Reason for Cancellation"
                                        id="reasonforCancellation"
                                        value={basicDetailsdata?.reasonforCancellation || ""}
                                        onChange={(e) => handleOnchange(e, "reasonforCancellation")}
                                        disabled={true}
                                    // disabled={viewmode || mappedStatus === 6}

                                    />
                                </Grid>
                                </>
                            )}
                        </Grid>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "flex-end" },
                            mt: 3,
                        }}
                    >
                        {/* <BottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} cancelWo={viewmode || !(access?.canCancel) ? false : checkcancelWOStatus} onEnableChange={onEnabledChange} enabel={enable} enableAuthorizeButton={enable} onConfirm={handleConfirmCancelWO} saveButton={location?.state?.isEditmode || location?.state?.viewmode ? false : true } saveButtonName={"Auto Assign"} disableSave={basicDetails?.id || location?.state?.id ? true : false} saveClick={handleOpenconfirmDialog} /> */}
                        <BottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} cancelWo={viewmode || !(access?.canCancel) ? false : checkcancelWOStatus} onEnableChange={onEnabledChange} enabel={enable} enableAuthorizeButton={enable} onConfirm={handleConfirmCancelWO} basicdetailsOnSubmit={(e) => handleSubmit(e)} isbasicdetailsTab = {true} saveButton={location?.state?.isEditmode || location?.state?.viewmode ? false : true } saveButtonName={"Auto Assign"} disableSave={basicDetails?.id || location?.state?.id ? true : false} saveClick={handleOpenconfirmDialog} />
                    </Box>

                </form>

                <CustomAlert
                    open={openAutoAsignDialog}
                    onClose={handleCloseAutoasignDialog}
                    onConfirm={handleConfirmAutoAsign}
                    content={`${basicDetails?.workOrderNo || ""} has been Created Successfully and Auto Assign initiated.`}
                    confirmBtn='OK'
                />

                <CustomAlert
                    open={errorDialog}
                    onClose={handleCloseErrRequestDialog}
                    onConfirm={handleConfirmErrRequestDialog}
                    content={errorDialogMssg}
                    confirmBtn='OK'
                />

                <CustomDialog
                    open={confirmationAutoAsign}
                    onClose={handleCloseConfirmationAutoAssignDialog}
                    onConfirm={handleConfirmforWOandAutoAsign}
                    content="Are you sure you want to Create Work Order and Auto Assign?"
                    cancelBtn="No"
                    confirmBtn="Yes"
                />

                <CustomDialog
                    open={cancelAutoAssign}
                    onClose={handleCloseCancelAutoAssignDialog}
                    onConfirm={handleConfirmCancelforAutoAsign}
                    content="Auto Assign in Initaited for the Work Order.Do you want to continue the Manual Assign?"
                    cancelBtn="No"
                    confirmBtn="Yes"
                /> 
            </Box>
        </>


    );
};

export default BasicDetails;
